import { defineRoute } from "src/routing/defineRoute";
import { developmentRoute } from "src/routing/domains/developments/detail/developmentDetailPaths";

/**
 * Path + typed URL builder pairs for development schedule SideNav leaves.
 *
 * Kept separate from the route tree so `RouteUrls.ts` and pages can import paths without a cycle
 * through page `Component` imports.
 */
export const developmentLegacyScheduleRoute = defineRoute(`${developmentRoute.path}/schedule`);
export const developmentLotSchedulesRoute = defineRoute(`${developmentRoute.path}/lot-schedules`);
export const developmentScheduleRoute = defineRoute(`${developmentRoute.path}/development-schedule`);
export const developmentTaskLookaheadReportRoute = defineRoute(`${developmentRoute.path}/reports/task-lookahead`);
